import {MaterialType} from '@domain/materials'
import {dataTestId} from '@hconnect/uikit'
import {TableCell, Typography} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'
const PREFIX = 'materialsSettings.classificationInputs'

interface Field {
  key: string
  minWidth?: string
}

interface ClassificationHeaderCellsProps {
  fields: Field[]
  materialType: MaterialType
}

export const ClassificationHeaderCells: React.FC<ClassificationHeaderCellsProps> = ({
  fields,
  materialType
}) => {
  const {t} = useTranslation()

  return (
    <>
      {fields.map(({key, minWidth}) => (
        <TableCell key={key} sx={{minWidth: minWidth}}>
          <Typography variant="caption" {...dataTestId(`${PREFIX}.${materialType}.${key}`)}>
            {t(`${PREFIX}.${materialType}.${key}`)}
          </Typography>
        </TableCell>
      ))}
    </>
  )
}
